import { render } from "./GiftList.vue?vue&type=template&id=7e10a7a5&scoped=true"
import script from "./GiftList.vue?vue&type=script&lang=js"
export * from "./GiftList.vue?vue&type=script&lang=js"

import "./GiftList.vue?vue&type=style&index=0&id=7e10a7a5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e10a7a5"]])

export default __exports__